<template lang="pug">
  .container.cardNovaConversa
    .card.fullWidth.cardPadding
      informacoes-conversa(v-if="idConversa" :idConversa="idConversa")
      el-row(v-if="!idConversa" type='flex' :gutter="30")
        el-col.container-input.marginTop(:md="12", :sm="24")
          validation-provider(rules="required", v-slot="{ errors }", name="Assunto", mode="lazy")
            app-label(label="Assunto:", :required="true")
            el-select.fullWidth(
              class="select",
              v-model="conversa.assunto",
              placeholder="Selecione",
              value-key="codigo",
              name="assunto",
              :class="{'erro' : errors.length}"
            )
              el-option(
                v-for="item in assuntos",
                :key="item.codigo",
                :label="item.nome",
                :value="item.codigo"
              )
            span.help.erro {{ errors[0] }}
      el-col.container-input
        validation-provider(rules="required", v-slot="{ errors }", name="Mensagem", mode="eager")
          app-label(label="Mensagem:", :required="true")
          app-text-editor(
            v-model="conversa.mensagem"
            :class="{'input erro': errors && errors.length > 0 ? true : false}"
            :config="config"
          )
          span.help.erro {{ errors[0] }}
      el-col.drop
        app-anexo(
          :id="'upload-atualizacao-base'"
          @uploadFile="uploadFile",
          :files="anexos",
          @removeFile="removeFile",
          @downloadDocumentoCadastro="getDownload"
        )
      el-col
        app-buttons-cadastro.btns(
          :isPrimeiroPasso="true",
          :isUltimoPasso="true",
          :showButtonFinalizar="false"
          :showButtonEnviar="(!!idConversa || !!conversa.assunto) && !!conversa.mensagem"
          @cancelar="cancelar",
          @enviar="enviar"
        )

</template>

<script>
import AppTextEditor from '@/components/AppTextEditor'
import AppLabel from '@/components/AppLabel'
import AppAnexo from '@/components/AppAnexo'
import axios from '@/utils/api'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import InformacoesConversa from '@/screens/central/components/comunicacao/InformacoesConversa'

import FileSaver from 'file-saver'
import { mapActions, mapGetters } from 'vuex'

export default {
  mixins: [
    AppNotificacao
  ],

  components: {
    AppTextEditor,
    AppLabel,
    AppAnexo,
    AppButtonsCadastro,
    InformacoesConversa
  },

  mounted () {
    if (process.env.ESTADO === 'ap') {
      const assuntoCopiaAp = {
        codigo: 'SOLICITACAO_DE_COPIA_DO_PROCESSO',
        nome: 'Solicitação de cópia do processo'
      }
      this.assuntos.splice(4, 0, assuntoCopiaAp)
    }
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },

  data () {
    return {
      assuntos: [
        {
          codigo: 'EM_QUAL_SETOR_SE_ENCONTRA_MEU_PROCESSO',
          nome: 'Em qual setor se encontra meu processo?'
        },
        {
          codigo: 'PORQUE_MEU_PROCESSO_ESTA_PARADO',
          nome: 'Por que meu processo está parado?'
        },
        {
          codigo: 'QUERO_DECLARACAO_TRAMITE_PROCESSUAL',
          nome: 'Quero declaração de tramite processual'
        },
        {
          codigo: 'INFORMAR_PROBLEMA_CADASTRO',
          nome: 'Informar problema no cadastro'
        },
        {
          codigo: 'DENUNCIAR_SERVIDOR',
          nome: 'Denunciar servidor(a)'
        },
        {
          codigo: 'OUTRAS_OPCOES',
          nome: 'Outros'
        }
      ],
      conversa: {
        assunto: '',
        mensagem: ''
      },
      anexos: [],
      config: {
        lang: 'pt-BR',
        placeholder: 'Digite o texto...',
        minHeight: 200,
        height: 350,
        maxHeight: 350
      },
      idConversa: this.$route.params.idConversa
    }
  },
  methods: {
    ...mapActions({
      criarMensagem: 'conversa/criarMensagem',
      responderMensagem: 'conversa/addMensagem'
    }),

    async uploadFile (file) {
      this.anexos = [...this.anexos, { key: file.response, nome: file.name }]
    },

    removeFile (file) {
      this.anexos.splice(this.anexos.findIndex(f => f === file), 1)
    },

    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },

    cancelar () {
      this.confirmBox('Você tem certeza que deseja cancelar? Todos os dados não salvos serão perdidos.', this.$messages.TITULO_WARNING,
        () => {
          this.$router.push({
            name: 'central/comunicacao'
          })
        },
        () => {
        }, 'Sim', 'Não')
    },

    async enviar () {
      const payloadMensagem = {
        assunto: this.idConversa ? null : this.conversa.assunto,
        tipo: 'OUVIDORIA',
        mensagemList: [
          {
            anexoList: this.anexos,
            conteudo: this.conversa.mensagem
          }
        ],
        id: this.idConversa ? this.idConversa : null
      }

      this.loading = true

      if (this.idConversa) {
        await this.responderMensagem(payloadMensagem)
      } else {
        await this.criarMensagem(payloadMensagem)
      }
      this.loading = false

      this.$router.push({ name: 'central/comunicacao' })
    }
  }

}
</script>

<style lang="scss" scoped>
.fullWidth {
  width: 100%;
}
.cardPadding {
  padding: 23px;
}
.marginTop {
  margin-top: 0;
}
.drop {
  margin-top: 10px;
}
.btns {
  padding-left: 0 !important;
}

@media (max-width: 780px) {
  .cardNovaConversa {
    position: absolute;
    top: 135px;
    left: 36px;
    width: 90% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/comunicacao/NovaConversa.vue